import React from 'react';
import { StepContainer, StepContent, StepActive } from './styles';

const Step = ({ children, active, completed, onClick, Title, isFirstRender, etapaExist }) => {
  return (
    <>
        {isFirstRender && (
            <StepContainer onClick={onClick}>
                <StepContent active={active} completed={completed} exist={etapaExist !== undefined}>
                    {Title}
                </StepContent>
            </StepContainer>
        )}
        {active && !isFirstRender && (
            <StepActive active={active} completed={completed} exist={etapaExist !== undefined}>
                {children}
            </StepActive>
        )}
    </>
  );
};

export default Step;
